// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskStatusEntity from './entities/task-status.json';
import taskStatusMenu from '../pages/task-status/menu.json';
import taskStatusFullForm from '../pages/task-status/forms/full.json';
import taskStatusContextForm from '../pages/task-status/forms/context.json';
import taskStatusMiniForm from '../pages/task-status/forms/mini.json';
import taskStatusLookupForm from '../pages/task-status/forms/lookup.json';
import taskStatusTableView from '../pages/task-status/views/table.json';
import taskStatusDashboardView from '../pages/task-status/views/dashboard.json';

/** Тип запису «Статус завдання» зі сторінками пакета: меню, форми та подання з pages/task-status/. */
export const taskStatusDefinition: IRecordTypeDefinition = {
  ...taskStatusEntity,
  views: assembleViewSet({
      table: taskStatusTableView,
      dashboard: taskStatusDashboardView,
  }),
  form: taskStatusFullForm,
  forms: { full: taskStatusFullForm, context: taskStatusContextForm, mini: taskStatusMiniForm, lookup: taskStatusLookupForm },
  menu: taskStatusMenu,
} as IRecordTypeDefinition;
